var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isShowVideoWidget,
          expression: "isShowVideoWidget"
        }
      ],
      staticClass: "video-widget-component",
      staticStyle: { display: "none" }
    },
    [
      _c(
        "div",
        { staticClass: "widget-container" },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isShowRegForm,
                  expression: "!isShowRegForm"
                }
              ],
              staticClass: "button-container"
            },
            [
              _c(
                "a",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isUser,
                      expression: "isUser"
                    }
                  ],
                  staticClass: "button button-filled",
                  attrs: {
                    href: "/declarations/",
                    "data-goal": "video-widget-start"
                  }
                },
                [_vm._v("Начать бесплатно")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isUser,
                      expression: "!isUser"
                    }
                  ],
                  staticClass: "button button-filled",
                  attrs: { "data-goal": "video-widget-start" },
                  on: { click: _vm.toggleShowRegForm }
                },
                [_vm._v("Начать бесплатно")]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "Registration",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isUser && _vm.isShowRegForm,
                  expression: "!isUser && isShowRegForm"
                }
              ],
              staticClass: "widget-rega",
              attrs: {
                "is-mobile-view": true,
                "explanation-enabled": false,
                "registration-goal": "reg_widget_video"
              },
              on: { callback: _vm.regCallback }
            },
            [
              _c("p", { staticClass: "reg-title" }, [
                _vm._v("Представьтесь, чтобы получить бесплатную консультацию")
              ])
            ]
          ),
          _vm._v(" "),
          _c("button", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isShowRegForm,
                expression: "isShowRegForm"
              }
            ],
            staticClass: "button close-reg",
            on: { click: _vm.toggleShowRegForm }
          }),
          _vm._v(" "),
          _c("button", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isShowVideoWidget && !_vm.isShowRegForm,
                expression: "isShowVideoWidget && !isShowRegForm"
              }
            ],
            staticClass: "button close-widget",
            on: { click: _vm.hideVideoWidget }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }